export const WHITELISTED_PORTAL_IDS_FOR_COMPLIANCE_SCRIPT = [2406023,
// Marketing web developer team portal in prod that they test against
99535353 // Portal 53 QA env
// 53, commented out for now while marketing web developer team is still testing their changes along with this PR
];
export const shouldLoadComplianceScript = portalId => {
  return WHITELISTED_PORTAL_IDS_FOR_COMPLIANCE_SCRIPT.includes(portalId);
};